import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer";
import Navbar from "../../Components/Header";
import NumberedCards from "../../Components/NumberedCrads";
import Pricing from "../../Components/PricingTable";
import bgplans from "../../Images/Frame.png";
import socialservice from "../../Images/Graphics PNG/socialmarketingservice1.png";
import commManagement from "../../Images/Social Media Marketing Services/Community Management.png";
import contentCreation from "../../Images/Social Media Marketing Services/Content Creation & Curation.png";
import influencerMarketing from "../../Images/Social Media Marketing Services/Influencer Marketing.png";
import paidAdvertising from "../../Images/Social Media Marketing Services/Paid Social Media Advertising.png";
import performanceTracking from "../../Images/Social Media Marketing Services/Performance Tracking & Reporting.png";
import strategyDevelopment from "../../Images/Social Media Marketing Services/Social Media Strategy Development.png";

const words = ["Unique", "High-Quality", "Specialized", "Exclusive"];

const SocialMediaMarketing = () => {
  const [currentWord, setCurrentWord] = useState(0);
  const [animate, setAnimate] = useState(false);

  const cardsData = [
    {
      title: "Social Media Strategy Development",
      description: [
        "Audience Analysis & Segmentation",
        "Competitor Analysis",
        "Platform Selection & Strategy",
        "Content Strategy & Planning",
        "Campaign Strategy & Execution",
      ],
      Icon: strategyDevelopment,
    },
    {
      title: "Content Creation & Curation",
      description: [
        "Graphic Design for Posts",
        "Video Content Creation",
        "Storytelling & Copywriting",
        "Branded Content Development",
        "User-Generated Content Strategy",
      ],
      Icon: contentCreation,
    },
    {
      title: "Paid Social Media Advertising",
      description: [
        "Ad Campaign Creation & Management",
        "Target Audience Definition",
        "Budget Allocation & Optimization",
        "A/B Testing & Ad Variations",
        "Retargeting & Remarketing Strategies",
      ],
      Icon: paidAdvertising,
    },
    {
      title: "Influencer Marketing",
      description: [
        "Influencer Identification & Outreach",
        "Campaign Strategy & Execution",
        "Content Collaboration & Co-creation",
        "Performance Tracking & Reporting",
      ],
      Icon: influencerMarketing,
    },
    {
      title: "Community Management",
      description: [
        "Engagement with Followers",
        "Responding to Comments & Messages",
        "Social Listening & Sentiment Analysis",
        "Crisis Management & Response",
        "Building & Managing Online Communities",
      ],
      Icon: commManagement,
    },
    {
      title: "Performance Tracking & Reporting",
      description: [
        "Monthly Performance Reports",
        "Campaign Analysis & Recommendations",
        "Social Media Analytics & Insights",
        "ROI Tracking & Optimization",
      ],
      Icon: performanceTracking,
    },
  ];

  const plans = [
    {
      name: "Basic",
      description:
        "A perfect starter package to establish your brand identity with essential elements.",
      features: [
        "Platform Setup & Optimization: Setting up and optimizing profiles on selected social media platforms.",
        "Content Planning: Basic content calendar for consistent posting.",
        "Content Creation: 8-10 custom posts per month.",
        "Basic Engagement: Responding to comments and messages.",
        "Monthly Reporting: Overview of social media performance.",
      ],
    },

    {
      name: "Standard",
      description:
        "Enhance your brand with comprehensive design assets and detailed guidelines.",
      features: [
        "Platform Setup & Optimization: Comprehensive profile setup and optimization.",
        "Content Planning & Strategy: Monthly content calendar with strategic planning.",
        "Content Creation: 12-15 custom posts per month, including graphics and captions.",
        "Community Management: Regular engagement with followers and community building.",
        "Ad Campaign Management: Basic ad campaign setup and monitoring.",
        "Monthly Reporting & Analysis: Detailed report with performance analysis and recommendations.",
      ],
      popular: true,
    },
    {
      name: "Premium",
      description:
        "Complete brand solutions with extensive design elements and strategic branding services.",
      features: [
        "Platform Setup & Optimization: Advanced profile setup and branding.",
        "Content Planning & Strategy: Custom content strategy with detailed planning.",
        "Content Creation: 20+ custom posts per month, including graphics, videos, and captions.",
        "Community Management: Active engagement, community building, and customer support.",
        "Ad Campaign Management: Comprehensive ad campaign management with advanced targeting.",
        "Influencer Marketing: Identification and collaboration with relevant influencers.",
        "Monthly Reporting & Strategy Review: In-depth reporting with strategic adjustments and recommendations.",
      ],
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate(true);

      setTimeout(() => {
        setCurrentWord((prevWord) => (prevWord + 1) % words.length);
        setAnimate(false);
      }, 500);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="md:snap-y md:snap-mandatory md:h-screen md:overflow-y-scroll lg:snap-y lg:snap-mandatory lg:h-screen lg:overflow-y-scroll">
      <div className="lg:snap-start lg:h-screen md:snap-start md:h-screen ">
        <div className="">
          <Navbar color={"bg-teal-950 text-white"} />
        </div>

        {/* Animated Text Section */}
        <div className=" flex flex-col justify-between">
          <div className="max-w-7xl   mx-auto px-4  lg:px-6 flex flex-col md:flex-row lg:flex-row gap-8 pb-20 lg:pt-12">
            {/* Left Side: Text Section */}
            <div className="flex flex-col justify-center w-full lg:w-1/2 md:w-1/2 mt-6 md:mt-6 lg:mt-10">
              <h1 className="relative h-12 mb-2 md:mb-4 lg:mb-4">
                <span
                  className={`absolute transition-transform duration-500 ease-in-out  text-2xl md:text-3xl lg:text-4xl font-bold text-teal-500`}
                >
                  {words[currentWord]}
                </span>
              </h1>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-teal-800">
                Social Media Marketing Services
              </h2>
              <p className="text-gray-600 mb-8 text-md md:text-lg lg:text-lg">
                Ignite the force of visual storytelling, from bespoke
                illustrations to captivating infographics, our talented artists
                sculpt mesmerizing designs that deeply connect with your
                audience and amplify your brand's message.
              </p>
            </div>

            {/* Right Side: Image Section */}
            <div className=" hidden md:flex lg:flex flex-col lg:flex-row md:flex-row justify-center items-center lg:justify-end w-full lg:w-1/2 md:w-1/2 mt-10 md:mt-0 lg:mt-0 xl:mt-0">
              <img
                src={socialservice}
                alt="Illustration Design"
                className="w-[250px] h-[250px] md:w-[400px] md:h-[350px] lg:w-[550px] lg:h-[500px]"
              />
            </div>
          </div>
        </div>
      </div>
      {/* Navbar */}

      {/* Numbered Cards Section */}
      <div className="lg:snap-start lg:h-screen  md:snap-start md:h-screen">
        <NumberedCards cardsData={cardsData} />
      </div>

      {/* Pricing Section */}
      <div className="lg:snap-start md:snap-start">
        <div
          className="w-full  mx-auto  "
          style={{
            backgroundImage: `url(${bgplans})`,
            backgroundSize: "cover",
            backgroundPosition: "top left",
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "fixed", // Fix background movement
          }}
        >
          <Pricing plans={plans} />
        </div>
      </div>

      {/* Footer */}
      <div className="lg:snap-start md:snap-start">
        <Footer />
      </div>
    </div>
  );
};

export default SocialMediaMarketing;
